<template>
    <div v-if="showing" class="opacity-0 transition-opacity duration-300" aria-labelledby="modal-title" role="dialog" aria-modal="true" :class="{'opacity-100': game}">
        <div class="flex min-h-full items-end justify-center p-0 text-center sm:items-center">
            <div class="relative overflow-hidden rounded-lg bg-white text-left shadow-xl w-full sm:max-w-lg">
                <div class="bg-white p-4 sm:p-6">
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/train.svg`" alt="Train Icon" class="w-5 h-5" />
                                <span>Train Stations</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showTrainStations" @change="update">
                        </label>
                    </div>
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/bus.svg`" alt="Bus Icon" class="w-5 h-5" />
                                <span>Bus Stations</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showBusStations" @change="update">
                        </label>
                    </div>
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/ferry.svg`" alt="Ferry Icon" class="w-5 h-5" />
                                <span>Boat Station</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showFerryStations" @change="update">
                        </label>
                    </div>
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/job.svg`" alt="Job Icon" class="w-5 h-5" />
                                <span>Jobs</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showJobs" @change="update">
                        </label>
                    </div>
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/hotel.svg`" alt="Hotel Icon" class="w-5 h-5" />
                                <span>Hotels</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showHotels" @change="update">
                        </label>
                    </div>
                    <div class="toggle-group">
                        <label class="flex justify-between items-center gap-x-4 w-full">
                            <span class="flex items-center gap-x-2">
                                <img :src="`${BaseUrl}img/icons/bank.svg`" alt="Bank Icon" class="w-5 h-5" />
                                <span>Banks</span>
                            </span>
                            <input type="checkbox" v-model="localSettings.showBanks" @change="update">
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { reactive, ref, watch } from "vue";
import { storeToRefs } from 'pinia';
import { useGameStore } from '@/stores/useGameStore.js';

const props = defineProps({
    // Provide initial settings if needed.
    initialSettings: {
        type: Object,
        default: () => ({
            showTrainStations: true,
            showBusStations: true,
            showFerryStations: true,
            showJobs: true,
            showHotels: true,
            showBanks: true,
        }),
    },
});

const emit = defineEmits(["update:modelValue", "updateSettings"]);

const BaseUrl = ref(baseUrl);

const gameStore = useGameStore();

const { game } = storeToRefs(gameStore);

const showing = defineModel('modelValue', {
    default: false,
    type: Boolean,
});
  
const localSettings = reactive({ ...props.initialSettings });
  
// When any checkbox changes, emit the updated settings.
function update() {
    emit("updateSettings", { ...localSettings });
}
  
function close() {
    emit("update:modelValue", false);
}
  
// In case the parent changes the initialSettings later.
watch(() => props.initialSettings, (newVal) => {
    Object.assign(localSettings, newVal);
}, { deep: true });
</script>
  
<style scoped>
.settings-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4000;
}
.settings-dialog {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 300px;
}
.toggle-group {
    margin-bottom: 10px;
}
.settings-dialog button {
    margin-top: 15px;
    padding: 8px 16px;
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
</style>
  